/* eslint-disable max-len */
export default {
  data() {
    return {
      isOpenConfigBlock: false,
      idConfigBlock: 'configurationBlock',
      selectedBlock: null,
      selectedIndexBlock: null,
      defaultSummaryBlockRequester: [
        {
          key: 'draft',
          name: 'Draft',
          color: '#808285',
          type: 'first_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'sent',
          name: 'Sent',
          color: '#F36F21',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'approved',
          name: 'Approved',
          color: '#42A5CE',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'closed',
          name: 'Closed',
          color: '#0C9C68',
          type: 'last_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'rejected',
          name: 'Rejected',
          color: '#8A0D4F',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'canceled',
          name: 'Canceled',
          color: '#4D3923',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
      ],
      defaultSummaryBlockApprover: [
        {
          key: 'sent',
          name: 'Sent',
          color: '#F36F21',
          type: 'first_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'approved_by_me',
          name: 'Approved By Me',
          color: '#42A5CE',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'approved',
          name: 'Approved',
          color: '#42A5CE',
          type: 'last_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'rejected',
          name: 'Rejected',
          color: '#8A0D4F',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
      ],
      lengthDefaultSummaryBlockRequester: 6,
      lengthDefaultSummaryBlockApprover: 4,
    };
  },

  methods: {
    setClassSummary(type) {
      switch (type) {
        case 'first_block':
          this.class = 'sum-start';
          break;
        case 'middle_block':
          this.class = 'sum-middle';
          break;
        case 'last_block':
          this.class = 'sum-last';
          break;
        case 'block':
          this.class = 'sum-alone-last';
          break;
        default:
          this.class = '';
          break;
      }
      return this.class;
    },

    setStyleSummary(data, color) {
      const styleColor = `--color:${color};`;
      const styleMargin = this.setStyleMargin(data);

      return `${styleColor}${styleMargin}`;
    },

    setStyleMargin(data) {
      const lastBlock = this.type === 'requestor' ? 2 : 1;
      let style = 'margin-left: 0px';
      if (this.index > 0) {
        const type = data[this.index].type;
        const blockBefore = data[this.index - 1].type;

        if (type === 'first_block') {
          if (blockBefore === 'first_block' || blockBefore === 'middle_block') {
            if ((this.index + 1) !== (data.length - lastBlock)) {
              style = 'margin-left: 27px';
            } else if ((this.index + 1) === (data.length - lastBlock)) {
              style = 'margin-left: 27px; margin-right: 33px';
            }
          } else if (blockBefore === 'last_block') {
            if ((this.index + 1) === (data.length - lastBlock)) {
              style = 'margin-right: 33px';
            }
          }
        } else if (type === 'middle_block') {
          if ((this.index + 1) === (data.length - lastBlock)) {
            style = 'margin-right: 33px';
          }
        }
      }

      return style;
    },

    isDefault(key) {
      let status = '';
      if (
        key === 'draft' || key === 'sent' ||
        key === 'approved' || key === 'approved_by_me' ||
        key === 'closed' || key === 'canceled' || key === 'rejected'
      ) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },

    openConfigBlock(block, index) {
      if (this.isOpenConfigBlock) {
        this.toggleConfigurationBlock(false);

        setTimeout(() => {
          this.selectedBlock = block;
          this.selectedIndexBlock = index;
          this.toggleConfigurationBlock(true);
        }, 250);
      } else {
        this.selectedBlock = block;
        this.selectedIndexBlock = index;

        this.toggleConfigurationBlock(true);
      }
    },

    toggleConfigurationBlock(status) {
      if (status) {
        this.isOpenConfigBlock = true;

        setTimeout(() => {
          const element = document.getElementById(this.idConfigBlock);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idConfigBlock);
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenConfigBlock = false;
          this.selectedBlock = null;
          this.selectedIndexBlock = null;
        }, 200);
      }
    },

    deleteBlock(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this block ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.summary_block.splice(index || this.selectedIndexBlock, 1);
          this.setChangesValueView(true);

          if (this.isOpenConfigBlock) this.toggleConfigurationBlock(false);
        }
      });
    },

    deleteBlockWithoutConfirm(index) {
      this.dataSetup.summary_block.splice(index || this.selectedIndexBlock, 1);
      this.setChangesValueView(true);

      if (this.isOpenConfigBlock) this.toggleConfigurationBlock(false);
    },

    submitBlock(mode, params, isCancel, type) {
      if (!isCancel) {
        const findKeySame = this.dataSetup.summary_block.find(e => e.key === params.key);
        if (mode === 'add') {
          if (!findKeySame) {
            this.submitDataConfig(mode, params, type);
          } else {
            this.toggleProblem('Key cannot be the same!');
          }
        } else {
          // eslint-disable-next-line
          if (this.selectedBlock.key === params.key) {
            this.submitDataConfig(mode, params, type);
          } else {
            // eslint-disable-next-line
            if (!findKeySame) {
              this.submitDataConfig(mode, params, type);
            } else {
              this.toggleProblem('Key cannot be the same!');
            }
          }
        }
      }
    },

    submitDataConfig(mode, data, type) {
      this.setChangesValueView(true);

      if (type === 'requestor' || type === 'approver') {
        const indexSubmit = type === 'requestor' ? -2 : -1;

        if (mode === 'add') {
          this.dataSetup.summary_block.splice(indexSubmit, 0, data);
        } else {
          this.dataSetup.summary_block[this.selectedIndexBlock] = data;
        }
      } else if (type === 'default') {
        if (mode === 'add') {
          this.dataSetup.summary_block.push(data);
        } else {
          this.dataSetup.summary_block[this.selectedIndexBlock] = data;
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixSetupSummaryBlock.js